import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { filter, takeUntil } from 'rxjs/operators';
import { QR_CODE_TYPE } from '@shared/models';
import { QrCodeService } from '@shared/services/qr-code.service';
import { UserService } from '@shared/services/user.service';
import { Subject } from 'rxjs';
import { LcoService } from '../../../lco/services/lco.service';

@Component({
  selector: 'app-location-label',
  templateUrl: './location-label.component.html',
  styleUrls: ['./location-label.component.scss']
})
export class LocationLabelComponent implements OnInit, OnDestroy {
  private destroySubject: Subject<any> = new Subject<any>();
  tableNumber = 0;
  location: string = '';

  constructor(private qrCodeService: QrCodeService,
              private userService: UserService,
              public lcoService: LcoService) {
    this.qrCodeService.parsedQrCode$
      .pipe(filter(x => !!x))
      .subscribe(res => {
        if (res.type === QR_CODE_TYPE.TABLE) {
          this.tableNumber = res.tableNumber;
        } else {
          this.tableNumber = 0;
        }
      });

    this.userService.location$
      .pipe(
        filter(location => !!location),
        takeUntil(this.destroySubject)
      )
      .subscribe((res) => {
        this.location = res?.locationName;
      });
  }

  ngOnInit(): void {
  }

  openChatBot() {

  }

  ngOnDestroy() {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
